module.exports = __webpack_public_path__ + "static/media/laugh-wink.86272130.svg";